import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { TranslateModule } from '@ngx-translate/core'
import { AppMaterialModule } from './app-material/app-material.module'
import { BackButtonComponent } from './core-components/backButton/back-button.component'
import { MomentTimezonePipeModule } from './pipes/moment-timezone-pipe.module'
import { ChartWrapperModule } from './shared-components/chart-wrapper/chart-wrapper.module'
import { CustomStatisticsModule } from './shared-components/custom-statistics/custom-statistics/custom-statistics.module'
import { GroupCustomStatisticsModule } from './shared-components/custom-statistics/group-custom-statistics/group-custom-statistics.module'
import { DisplayBase64ImageModule } from './shared-components/display-base-64-image/display-base-64-image.module'
import { PdfExporterModule } from './shared-components/pdf-exporter/pdf-exporter.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    AppMaterialModule,
    TranslateModule,
    RouterModule,
    MomentTimezonePipeModule,
    CustomStatisticsModule,
    GroupCustomStatisticsModule,
    DisplayBase64ImageModule,
    ChartWrapperModule,
    PdfExporterModule
  ],
  declarations: [BackButtonComponent],
  entryComponents: [BackButtonComponent],
  exports: [
    BackButtonComponent,
    MomentTimezonePipeModule,
    CustomStatisticsModule,
    GroupCustomStatisticsModule,
    DisplayBase64ImageModule,
    ChartWrapperModule
  ],
})
export class SharedComponentsModule { }
